import { getLeaderboardTimeframe } from "@/sales-tools/leaderboard/api/getLeaderboardTimeframe";
import { userCache } from "@/shared-utils";
import { ChecklistSummaryView } from "./ChecklistSummaryView";
import { useChecklistSummaryQuery } from "./hooks/useChecklistSummaryQuery";

export function ChecklistSummary() {
    const { start, end } = getLeaderboardTimeframe();
    const { data, isLoading } = useChecklistSummaryQuery({
        params: {
            adGroups: userCache.groups,
            start,
            end,
        },
    });

    return <ChecklistSummaryView stats={data} isLoading={isLoading} />;
}
